export const experienceIds = {
  isProfileLockedV2: '17167418-02ee-48e2-b52a-72987b375bc4',
  lookupV2: '35387ee0-1278-4520-8d0d-2969c2684dfd',
  profileLookup: 'dd732fcc-d38f-4ced-befb-9ef4359819c3',
  initiateMFA: '559cc9ab-77ca-4a94-b66d-730cf206b227',
  cmkSecurityAccountLookup: '1d4bde78-7d73-475f-bcd8-28f5abf4c74b',
  spltySecurityAccountLookup: 'af1ce6de-6601-498f-8ad7-a5e850e50247',
  logout: 'bee34bae-d82c-4a3b-af8c-a222c86b4e0b',
  guestPhoneDOBLookup: 'bf0648fa-1fc4-4acf-bf1b-e5ff934e8118',
  guestRxLabelLookup: '786a52ba-d274-485c-bf4e-0e6b46e6e52b',
  getCampaignInfo: '81340b92-8193-4b53-b874-cfaf922bb8d3',
  spltyUnlockAccountLookup: 'ed37d49e-75e4-4c68-88c9-5d5e3669191c'
};
